import { GetAllSession } from "../../../../../api/ai/types";
import { DataItemsProps } from "../../../components/type";
import FibiSessionAction from "./FibiSessionAction";

export const FiBiSessionsTableData = (isDownload?: boolean, buid?: string) => [
  {
    columnName: "Date",
    columnKey: "date",
  },
  {
    columnName: "Duration",
    columnKey: "duration",
  },
  {
    columnName: "Overall Performance (%)",
    columnKey: "overallScore",
    customComp: (data: DataItemsProps) => {
      const temp = data as GetAllSession;
      return <>{temp.overallScore}/100</>;
    },
  },
  {
    columnName: "Visa Category",
    columnKey: "interviewType",
    customComp: (data: DataItemsProps) => {
      const temp = data as GetAllSession;
      return <div className="capitalize">{temp.interviewType || "N/A"}</div>;
    },
  },
  {
    columnName: "Action",
    customComp: (data: DataItemsProps) => (
      <FibiSessionAction data={data as GetAllSession} isDownload={isDownload} buid={buid} />
    ),
    hideOnDetails: true,
  },
];
